const VyttraProximaThemeVariables: Record<string, any> = {
  manufacturer: 'Vyttra',
  pageTitle: 'WebApp - COVID-19 Ag Proxima Nasal',
  backgroundDisableButton: '#C6E0E5',
  backgroundBase: '#53A4B3',
  backgroundBaseFilter:
    "invert(58%) sepia(92%) saturate(299%) hue-rotate(129deg) brightness(86%) contrast(91%)",
  backgroundBaseGradient: "#f9b70f",
  backgroundDaxQRCode: "linear-gradient(to right, #53A4B3, #f9b70f, #53A4B3)",
  backgroundLoaderResult:
    "linear-gradient(96.38deg, #389AA3 0%, #53A4B3 22.06%, #2A969F 100%)",
  backgroundLoaderAnimationStepA:
    "linear-gradient(96.38deg, #389AA3 0%, #53A4B3 22.06%, #2A969F 100%)",
  backgroundLoaderAnimationStepB:
    "linear-gradient(96.38deg, #389AA3 0%, #53A4B3 22.06%, #2A969F 100%)",
  backgroundLoaderAnimationStepC:
    "linear-gradient(96.38deg, #389AA3 0%, #53A4B3 22.06%, #2A969F 100%)",
  backgroundLoaderBar:
    'linear-gradient(90deg, rgba(80, 165, 81, 0) 0%, #50A551 45.16%, rgba(80, 165, 81, 0) 100%)',
  backgroundShareResult: '#F7FCFA',
  backgroundShareScreen: '#F7FCFA',
  ResultShareModal: '#53A4B3',
  ResultShareModalTitle: '#ffffff',
  backgroundStrongBase: '#BAB7B5',
  backgroundExportButton: '#53A4B3',
  urlTest: 'https://proximadx.com/autoteste/covid/#home',
  urlPathLoaderFile: 'vyttra/proxima/vyttra_preparing_results.png',
  urlPathLogoFile: 'vyttra/proxima/proxima_logo_start.png',
  urlPathLogoFileWhiteHeader: 'vyttra/proxima/proxima_top_logo.svg',
  urlPathLogoFileWhite: 'vyttra/proxima/proxima_logo_start.png',
  urlPathLogoResult: 'vyttra/proxima/proxima_logo_start.png',
  urlPathLogoFileCrx: 'clinicarx-logo-green.png',
  urlFavicon: 'vyttra/proxima/favicon.png',
  logoWidth: '156px',
  logoHeight: '86px',
  logoWidthWhite: '130px',
  logoHeightWhite: '31px',
  logoWidthResult: '108px',
  logoWhiteTopMargin: '30px',
  logoHeightResult: '35px',
  logoWidthWhiteDask: '243px',
  logoHeightWhiteDask: '80px',
  testName: 'COVID-19 Ag Proxima Nasal',
  urlPathTestImage: 'vyttra/proxima/proxima_covid_box.png',
  urlPathDocumentIcon: 'eco/card-result.png',
  urlVideoGuidelines: 'https://www.youtube.com/embed/nkZy-8I7S6I',
  urlPathQRCode: 'vyttra/proxima/QR_Proxima.png',
  socialShareInfo:
    "Acabei de gerar o cartão de resultado do meu Autoteste COVID Ag Detect da Proxima Nasal. Fazer o autoteste é cuidar de você e de quem você ama.",
  totalSteps: 8,
  testStepOneContents: {
    title: "Colete a amostra:",
    steps:
      "<ol> <li>Assoe o nariz e higienize as mãos;</li><li>Abra o envelope do cotonete (swab);</li><li>Insira o swab aproximadamente 1,5 cm na narina e gire 5 vezes contra a parede nasal. Repita o procedimento na outra narina com o mesmo swab.</li></ol>",
    image: "vyttra/proxima/vyttra_gif_a.gif",
    warningActive: true,
    warningText:
      "Não toque com a sua mão na ponta de algodão do cotonete (swab).",
  },
  testStepTwoContents: {
    title: "Prepare sua amostra para o teste:",
    steps:
      "<ol><li>Pegue o tubo com o líquido diluente;</li><li>Remova a tampa superior (maior) e insira o swab com a amostra coletada;</li><li>Gire 5 vezes contra a parede do tubo, lavando o swab no diluente;</li><li>Segure o tubo e quebre o swab na marcação. Deixe a outra metade do swab dentro do tubo e feche.</li></ol>",
    image: "vyttra/proxima/vyttra_gif_b.gif",
    warningActive: true,
    warningText:
      "Caso ocorra contato da solução com sua pele ou olhos, lave imediatamente com água.",
  },
  testStepThreeContents: {
    title: "Pingue as gotas no dispositivo:",
    steps:
      "<ol><li>Retire o dispositivo do teste da embalagem;</li><li>Abra a tampa inferior do tubo (gotejador);</li><li>Mantenha o tubo na vertical e aperte no local indicado na etiqueta;</li><li>Pingue 3 gotas na cavidade oval “S” e feche a tampa do gotejador.</li></ol>",
    image: "vyttra/proxima/vyttra_gif_c.gif",
    warningActive: true,
    warningText:
      "Atenção com a contagem das gotas. Não aplique mais de 3 gotas.",
    timerInMinutes: 15,
  },
  testStepEightContents: {
    title: "Informe os demais dados pessoais",
    warningText:
      "Utilizamos o CPF para reforçar sua identidade no cartão de resultado compartilhável do teste e para seu cadastro com a Clinicarx.",
  },
  logoViewResultCardHeight: '29px',
  logoViewResultCardWidth: '90px',
  testStepFourContents: {
    title: "Informe o resultado do autoteste",
    warningText:
      'A intensidade da cor das linhas no dispositivo podem variar e mesmo os tons mais claros devem ser considerados. <span id="modalLink" style="color: #006ba6; text-decoration: underline;"> Clique aqui se o resultado não mostra a linha “C”.</span>',
  },
  testStepFiveContents: {
    title: "Tire uma foto do resultado do autoteste",
    warningText:
      '<span id="modalLink" style="color: #006ba6; text-decoration: underline;">Ver instruções e exemplo de como tirar a foto.</span>',
  },
  backgrounBaseLinear:
    "linear-gradient(196.38deg, #389AA3 0%, #53A4B3 22.06%, #2A969F 100%)",

  // Result image variables
  urlNegativeWithoutSymptomsImage:
    "vyttra/proxima/proxima-negative-without-symptons.png",
  heightNegativeWithoutSymptomsImage: "173px",
  widthNegativeWithoutSymptomsImage: "173px",
  urlNegativeWithSymptomsImage:
    "vyttra/proxima/proxima-negative-with-symptons.png",
  heightNegativeWithSymptomsImage: "124px",
  widthNegativeWithSymptomsImage: "122px",
  urlPositiveWithoutSymptomsImage:
    "vyttra/proxima/proxima-positive-without-symptons.png",
  heightPositiveWithoutSymptomsImage: "121px",
  widthPositiveWithoutSymptomsImage: "173px",
  urlPositiveWithSymptomsImage:
    "vyttra/proxima/proxima-positive-with-symptons.png",
  heightPositiveWithSymptomsImage: "124px",
  widthPositiveWithSymptomsImage: "150px",
};

export { VyttraProximaThemeVariables };
